import { HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';


import { OrganizationStudyListResponse } from '../types';



@Injectable({
    providedIn: 'root'
})
export class StudyListService {
  private readonly _http = inject(HttpClient);


    getStudyList(studyURL: string, params: HttpParams) {
    return this._http.get<OrganizationStudyListResponse>(studyURL, {
      params: params,
    });
  }

}